<script setup lang="ts">
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import { useSettingPageEntranceSwitchViewQuery } from './SettingsPageSwitchEntranceView.generated'

const { result } = useSettingPageEntranceSwitchViewQuery()
</script>

<template>
  <SettingsPagePanel>
    <SettingsPagePanelHeader>
      <template #title>アカウント変更</template>
    </SettingsPagePanelHeader>
    <ul v-if="result" :class="$style.list">
      <li
        v-for="entrance in result.entrances"
        :key="entrance.guid"
        :class="$style.list__item"
      >
        <router-link
          :to="{
            name: 'settings',
            params: { entranceGUID: entrance.guid },
          }"
          :class="$style['listItem']"
        >
          <p>
            {{ entrance.name }}
          </p>
        </router-link>
      </li>
    </ul>
  </SettingsPagePanel>
</template>

<style lang="scss" module>
.list {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &:nth-child(n + 2) {
    margin-top: 12px;
  }

  &__item {
    border: 1px solid $color-border-low-emphasis;
    border-radius: $border-radius-v2-base;
    padding: 16px;

    &:hover {
      background-color: $color-surface-accent-primary-light;
    }
  }

  &__checkbox {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px;
    pointer-events: auto;
  }
}

.listItem {
  align-items: center;
  display: flex;
  justify-content: space-between;

  &__badge {
    display: flex;
    gap: 4px;
  }
}
</style>
